import { from, Observable, of } from 'rxjs';
import { IModel } from '../base/annotation';
import { Named } from '../base/named';

export interface IModelService {
    fetch<T extends Named>(named: T): Promise<T>;
    list(regex?: RegExp, ...types: IModel[]): Observable<Named[]>;
}

export const MODEL_SERVICE_LIST_TIMEOUT = { each: 5, with: () => from([]) };
export const MODEL_SERVICE_LIST_TIMEOUT_OF = { each: 5, with: () => of([]) };
